import { useTranslation } from '@/features/shared/composables/useTranslation'
import { PERMISSIONS } from '@/features/shared/constants/permissions'

const t = useTranslation()

export const userRoutes = [
  {
    path: 'users',
    name: 'Users',
    component: () => import('@/features/users/views/Users.vue'),
    meta: {
      permissionIdentifiers: [PERMISSIONS.CAN_VIEW_USER, PERMISSIONS.CAN_VIEW_INVITATIONS],
      title: `${t('users')} | Pour Now`,
    },
  },
  {
    path: 'users/new',
    name: 'AddUser',
    component: () => import('@/features/users/views/AddEditUser.vue'),
    meta: {
      permissionIdentifier: [PERMISSIONS.CAN_INVITE_USER],
      title: `${t('add_user')} | Pour Now`,
    },
  },
  {
    path: 'users/:userId',
    name: 'EditUser',
    component: () => import('@/features/users/views/AddEditUser.vue'),
    meta: {
      permissionIdentifier: [PERMISSIONS.CAN_UPDATE_USER],
      title: `${t('edit_user')} | Pour Now`,
    },
  },
]
